<template>
    <label
        class="dk-configuration-engine-card tw-group tw-w-full lg:tw-h-[330px] tw-flex tw-flex-col tw-gap-2 tw-p-4 lg:tw-p-6 tw-border tw-border-solid tw-rounded"
        :class="{
            'tw-border-border-color tw-duration-300 hover:lg:tw-border-slate-500 hover:lg:tw-bg-secondary-light tw-cursor-pointer': !isSelected,
            'tw-border-brand-primary tw-bg-primary-light': isSelected,
        }"
        @click.stop="onClick"
    >
        <div class="dk-configuration-engine-card__wrapper tw-flex tw-items-center lg:tw-gap-2">
            <input
                :id="`radio-version-${versionId}`"
                class="dk-configuration-engine-card__radio tw-shrink-0 checked:tw-border-brand-primary checked:before:!tw-bg-brand-primary"
                type="radio"
                value="value"
                :checked="isSelected"
            >
            <h3
                class="dk-configuration-engine-card__name tw-font-semibold tw-text-base tw-leading-base lg:tw-text-2xl lg:tw-leading-lg"
            >
                {{ versionName }}
            </h3>
        </div>
        <div class="dk-configuration-engine-card__tags tw-flex tw-gap-2 lg:tw-gap-4 tw-pointer-events-none">
            <dk-tag
                v-for="(tag, index) in badges"
                :key="`tag-${index}`"
                :label="tag.name"
                class="dk-configuration-engine-card__tag !tw-py-1"
                label-classes="!tw-text-base !tw-mb-0 tw-leading-sm"
                :with-dismiss="false"
            />
        </div>
        <div
            class="dk-configuration-engine-card__values-wrapper tw-flex tw-flex-col tw-justify-between tw-grow tw-gap-4 tw-mt-3 lg:tw-mt-1 lg:tw-gap-6"
        >
            <div class="dk-configuration-engine-card__values tw-w-full tw-flex tw-flex-col tw-gap-0">
                <div v-for="(detail, key, index) in engineDetails" :key="`detail-${key}`" class="tw-flex tw-flex-col">
                    <div
                        class="tw-min-w-0 tw-flex tw-justify-between tw-items-center tw-px-1 lg:tw-px-0 lg:tw-py-1"
                        :class="`dk-configuration-engine-card__${key}`"
                    >
                        <span
                            class="tw-text-xs lg:tw-text-base tw-leading-sm lg:tw-leading-base"
                            :class="`dk-configuration-engine-card__${key}-text`"
                        >
                            {{ detail.label }}
                        </span>
                        <span
                            class="tw-text-xs lg:tw-text-base tw-font-bold tw-leading-xs lg:tw-leading-base"
                            :class="`dk-configuration-engine-card__${key}-value`"
                        >
                            {{ detail.value }}
                        </span>
                    </div>
                    <dk-divider
                        class="dk-configuration-engine-card__divider tw-w-full"
                        :class="{ 'max-lg:tw-hidden': index === Object.keys(engineDetails).length - 1 }"
                    />
                </div>
            </div>
            <div
                class="dk-configuration-engine-card__price tw-flex tw-justify-between tw-items-center tw-px-1 lg:tw-px-0"
            >
                <span
                    class="dk-configuration-engine-card__price-text tw-text-xs lg:tw-text-base tw-leading-xs lg:tw-leading-base"
                >
                    {{ pricing.label }}
                </span>
                <div class="tw-flex tw-items-end">
                    <span
                        v-if="pricing.originalPrice && pricing.originalPrice !== pricing.finalPrice"
                        class="dk-configuration-engine-card__price-before tw-mb-[3px] lg:tw-mb-[2px] tw-mr-1 tw-text-2xs lg:tw-text-xs tw-leading-2xs lg:tw-leading-xs tw-line-through"
                    >
                        {{ priceBefore }}
                    </span>
                    <span
                        class="dk-configuration-engine-card__price-after tw-text-xs tw-font-bold tw-leading-sm tw-mr-[2px] lg:tw-leading-base lg:tw-text-xl"
                    >
                        {{ pricing.finalPrice }}
                    </span>
                </div>
            </div>
        </div>
    </label>
</template>

<script>
export default {
    name: 'DkConfigurationEngineCard',
    components: {
        DkTag: () => ({
            component: import(/* webpackChunkName: "DkTag-vue" */ '@v4/common/components/atoms/DkTag.vue'),
        }),
        DkDivider: () => ({
            component: import(/* webpackChunkName: "DkDivider-vue" */ '@v4/common/components/atoms/DkDivider.vue'),
        }),
    },
    props: {
        /**
         * The version ID
         */
        versionId: {
            type: String,
            default: '',
        },
        versionName: {
            type: String,
            required: true,
        },
        /*
         * Badges names
         */
        badges: {
            type: Array,
            default: () => [],
        },
        power: {
            type: Object,
            required: true,
        },
        co2: {
            type: Object,
            required: true,
        },
        fuelConsumption: {
            type: Object,
            required: true,
        },
        pricing: {
            type: Object,
            required: true,
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            engineDetails: {
                power: {
                    ...this.power,
                },
                co2: {
                    ...this.co2,
                },
                fuelConsumption: {
                    ...this.fuelConsumption,
                },
            },
        };
    },
    methods: {
        onClick($event) {
            /**
             * Fired when clicked on the version item
             *
             * @event click
             * @type {object}
             * @property {object} $event - Click event
             * @property {object} id - Item versionId
             */
            this.$emit('click', {
                $event,
                versionId: this.versionId,
            });
        },
    },
};
</script>
